import styled from "styled-components";

interface StyleProps {}

export const SpanCartLoadingSpinner = styled.span<StyleProps>`
  & {
    content: "";

    ::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 40px;
      height: 40px;
      border-radius: 100%;
      border-top: 5px solid black;
      border-style: outset;
      z-index: 110;
      animation: modalLoaderAnimation 1s infinite;
    }

    ::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.9);
      z-index: 100;
    }
  }
`;
